import { AddemployeebillingComponent } from './addemployeebilling/addemployeebilling.component';
import { ViewemployeebillingComponent } from './viewemployeebilling/viewemployeebilling.component';

export const EmpoloyeeBillingDeclatation = [
    AddemployeebillingComponent, ViewemployeebillingComponent
];
